import React from 'react'
import { EmptyState } from 'Components/Pages/Impact/ImpactReportDashboard/EmptyState/EmptyState'
import { ContentPasteOff } from '@mui/icons-material'

type TaskListEmptyStateProps = {
  tabName: string
}

export const TaskListEmptyState = ({ tabName }: TaskListEmptyStateProps) => {
  const getDescription = (tabNameLabel: string) =>
    tabName === 'all'
      ? 'All tasks will appear here once you and your team create them.'
      : `Your ${tabNameLabel} tasks will appear here.`

  return (
    <EmptyState
      icon={ContentPasteOff}
      title='No Tasks'
      description={getDescription(tabName)}
    />
  )
}
